import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

const MobileNavMemuItem = styled("li")`
  display: inline-block;
  text-align: center;
  a {
    position: relative;
    padding: 16px 0;
    text-transform: uppercase;
    font-weight: ${themeGet("fontWeights.semiBold")};
    font-size: 18px;
    color: ${themeGet("colors.white.100")};
    cursor: pointer;
    &:after {
      content: "";
      position: absolute;
      bottom: 11px;
      left: 0;
      right: 0;
      height: 2px;
      width: 100%;
      border-bottom: 2px solid
        ${props =>
          props.active ? themeGet("colors.white.100") : "transparent"};
    }
  }
`;

export { MobileNavMemuItem };
